export const BUILD_ID = "build-" + String(Date.now());
